import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import TableHead from "./TableHead";
import TableHeadCell from "./TableHeadCell";

import "./table.scss";

const Table = ({
  children,
  className,
  isStriped,
  isScrolling,
  isStickyColumns,
  cols,
  ...props
}) => {
  const classes = classNames(
    "responsive-table",
    {
      "responsive-table--sticky-columns": isStickyColumns,
      "responsive-table--scrolling": isScrolling,
      "responsive-table--is-striped": isStriped,
    },
    className
  );

  const renderHeader = () => (
    <>
      {cols && (
        <TableHead>
          {cols.map(column => (
            <TableHeadCell key={column.label} scope="col">
              {column.text}
            </TableHeadCell>
          ))}
        </TableHead>
      )}
    </>
  );

  return (
    <div className={classes} {...props}>
      <div className="responsive-table__inner">
        <table>
          {renderHeader()}
          {children}
        </table>
      </div>
    </div>
  );
};

Table.propTypes = {
  /**
   *  An array of objects representing the table column headers
   */
  cols: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  /**
   * This flag will render striped table rows
   */
  isStriped: PropTypes.bool,
  /**
   * This flag will enable horizontal scrolling when the table conent is wider than it's container
   */
  isScrolling: PropTypes.bool,
  /**
   * This flag will make the first column position sticky on tablet screen sizes and greater.
   */
  isStickyColumns: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

export default Table;

// ### Properties
// | Prop             | Required | Default | Type   | Description                                                 |
// | :--------------- | :------- | :------ | :----- | :---------------------------------------------------------- |
// | `cols` | true     | -  | array | An array of objects representing the table column headers  |
// | `isStriped`  | false   | false | bool | This flag will render striped table rows |
// | `isScrolling`  | false    | false | bool   | This flag will enable horizontal scrolling when the table conent is wider than it's container |
// | `isStickyColumns`  | false    | false | bool | This flag will make the first column position sticky on tablet screen sizes and greater. |
// | `children` | false    | true       | node   | Child nodes which make up the content and structure of the table  |
// | `className`      | false    | -       | string | Custom className(s) to add to the component  |
